// import React, { useEffect, useState } from "react";
// import {
//   FaFacebookF,
//   FaYoutube,
//   FaLinkedinIn,
//   FaInstagram,
//   FaXTwitter,
// } from "react-icons/fa6";
// import axios from "axios";
// import { FaHouse } from "react-icons/fa6";

// import { useHistory } from "react-router-dom";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   const history = useHistory();

//   const handleNavigation = (path) => {
//     history.push(path);
//   };

//   const handleCityClick = (cityName) => {
//     window.scrollTo(0, 0);
//     history.push(`/citywiseproperties/${cityName}`);
//   };

//   const [socialLinks, setSocialLinks] = useState({
//     facebook: "#",
//     youtube: "#",
//     linkedin: "#",
//     instagram: "#",
//     appstore: "#",
//     playstore: "#",
//     twitter: "#",
//   });

//   useEffect(() => {
//     const fetchSettings = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/cust_api/get_setting`
//         );
//         if (response.data.status === 1 && response.data.data.length > 0) {
//           const data = response.data.data[0];
//           setSocialLinks({
//             facebook: data.facebook || "#",
//             youtube: data.youtube || "#",
//             linkedin: data.linkedin || "#",
//             instagram: data.instagram || "#",
//             appstore: data.appstore || "#",
//             playstore: data.playstore || "#",
//             twitter: data.twitter || "#",
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching social links:", error);
//       }
//     };
//     fetchSettings();
//   }, []);

//   const icons = [
//     { icon: FaFacebookF, link: socialLinks.facebook },
//     { icon: FaYoutube, link: socialLinks.youtube },
//     { icon: FaLinkedinIn, link: socialLinks.linkedin },
//     { icon: FaInstagram, link: socialLinks.instagram },
//     { icon: FaXTwitter, link: socialLinks.twitter },
//   ];

//   return (
//     <footer
//       className="py-6 bg-white shadow-sm"
//       style={{ boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)" }}
//     >
//       <div className="max-w-[1450px] mx-auto px-4">
//         {/* Top Section */}
//         <div className="grid grid-cols-1 gap-8 pb-8 border-b border-gray-300 md:grid-cols-12">
//           <div className="grid grid-cols-1 gap-8 md:col-span-12 md:grid-cols-12">
//             {/* Company Info */}
//             <div className="flex flex-col items-start md:col-span-5">
//               <Link to="/">
//                 <img
//                   src="/app1.png"
//                   alt="ZeroBriks Logo"
//                   className="w-32 h-auto object-contain mb-4"
//                 />
//               </Link>
//               <p className="text-gray-500 text-[17px] leading-relaxed">
//                 We offer full-stack services for all real estate needs,
//                 including home loans, pay rent, packers and movers, legal
//                 assistance, property valuation, and expert advice.
//               </p>
//             </div>

//             {/* Company Links */}
//             <div className="md:col-span-2">
//               <h3 className="text-gray-700 text-[18px] font-semibold mb-4 ml-4">
//                 COMPANY
//               </h3>
//               <ul className="space-y-3">
//                 <li>
//                   <span
//                     onClick={() => handleNavigation("/about-us")}
//                     className="text-gray-500 hover:text-gray-700 text-[17px] font-medium no-underline hover:no-underline cursor-pointer transition-colors"
//                   >
//                     About
//                   </span>
//                 </li>
//                 <li>
//                   <span
//                     onClick={() => handleNavigation("/faq")}
//                     className="text-gray-500 hover:text-gray-700 text-[17px] font-medium no-underline hover:no-underline cursor-pointer transition-colors"
//                   >
//                     FAQ
//                   </span>
//                 </li>
//                 <li>
//                   <span
//                     onClick={() => handleNavigation("/contact")}
//                     className="text-gray-500 hover:text-gray-700 text-[17px] font-medium no-underline hover:no-underline cursor-pointer transition-colors"
//                   >
//                     Contact Us
//                   </span>
//                 </li>
//                 {/* ✅ NRI Page Link Added Below */}
//                 <li>
//                   <span
//                     onClick={() => handleNavigation("/nri")}
//                     className="text-gray-500 hover:text-gray-700 text-[17px] font-medium no-underline hover:no-underline cursor-pointer transition-colors"
//                   >
//                     NRI
//                   </span>
//                 </li>
//               </ul>
//             </div>

//             {/* Properties in India */}
//             <div className="md:col-span-5">
//               <h3 className="text-gray-700 text-[18px] font-semibold mb-4">
//                 PROPERTIES IN INDIA
//               </h3>
//               <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
//                 {[
//                   "Delhi",
//                   "Mumbai",
//                   "Chennai",
//                   "Pune",
//                   "Noida",
//                   "Gurgaon",
//                 ].map((city) => (
//                   <button
//                     key={city}
//                     onClick={() => handleCityClick(city)}
//                     className="text-left text-gray-500 hover:text-gray-700 text-[17px] font-medium hover:no-underline no-underline transition-colors"
//                   >
//                     Property in {city}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Middle Section */}
//         <div className="flex flex-col items-center justify-between py-8 border-b border-gray-300 md:flex-row gap-8">
//           <div className="flex flex-col items-center md:items-start">
//             <h4 className="text-gray-700 text-[18px] font-semibold mb-4">
//               DOWNLOAD MOBILE APP
//             </h4>
//             <div className="flex space-x-4 mb-6">
//               <a
//                 href={socialLinks.playstore}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src="/image/abc.jpg"
//                   alt="Google Play"
//                   className="h-12 object-contain rounded-lg hover:shadow-md transition-shadow"
//                 />
//               </a>
//               <a
//                 href={socialLinks.appstore}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   src="/image/apl.png"
//                   alt="App Store"
//                   className="h-12 object-contain rounded-lg hover:shadow-md transition-shadow"
//                 />
//               </a>
//             </div>
//             <div className="flex flex-col items-center md:flex-row md:items-start">
//               <img
//                 src="/image/qrbar.jpg"
//                 alt="QR Code"
//                 className="h-24 object-contain"
//               />
//               <p className="text-[17px] text-gray-600 md:ml-4 mt-4 md:mt-0 text-center md:text-left">
//                 Scan the QR code to download the app.
//               </p>
//             </div>
//           </div>

//           {/* Social Links */}
//           <div className="flex flex-col items-center md:items-start">
//             <h4 className="text-gray-700 text-[18px] font-semibold mb-4">
//               WE IN SOCIAL
//             </h4>
//             <div className="flex space-x-4">
//               {icons.map(({ icon: Icon, link }, index) => (
//                 <a
//                   key={index}
//                   href={link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="p-2 text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 transition-all hover:shadow-md"
//                 >
//                   <Icon size={20} />
//                 </a>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Bottom Section */}
//         <div className="flex flex-col items-center justify-between py-4 md:flex-row gap-4">
//           <div className="flex items-center space-x-2">
//             <img src="/app1.png" alt="ZeroBriks Logo" className="w-20 h-auto object-contain" />
//             <span className="text-sm text-gray-500">
//               © 2026 ZeroBriks ALL RIGHTS RESERVED
//             </span>
//           </div>
//           <div className="flex mt-4 space-x-8 md:mt-0">
//             <Link
//               to="/privacy-policy"
//               className="text-xs text-gray-500 no-underline hover:text-gray-700 hover:no-underline transition-colors"
//             >
//               PRIVACY POLICY
//             </Link>
//             <Link
//               to="/terms-conditions"
//               className="text-xs text-gray-500 no-underline hover:text-gray-700 hover:no-underline transition-colors"
//             >
//               TERMS OF SERVICE
//             </Link>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import React, { useEffect, useState } from "react";
import {
  FaFacebookF,
  FaYoutube,
  FaLinkedinIn,
  FaInstagram,
  FaXTwitter,
  FaChevronRight,
  FaBuilding,
} from "react-icons/fa6";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import {
  IoShieldCheckmarkOutline,
  IoPeopleOutline,
  IoHomeOutline,
  IoTrendingUpOutline,
} from "react-icons/io5";
import axios from "axios";
import { useHistory, Link } from "react-router-dom";

const Footer = () => {
  const history = useHistory();

  const handleNavigation = (path) => {
    window.scrollTo(0, 0);
    history.push(path);
  };

  const handleCityClick = (cityName) => {
    window.scrollTo(0, 0);
    history.push(`/citywiseproperties/${cityName}`);
  };

  const [socialLinks, setSocialLinks] = useState({
    facebook: "#",
    youtube: "#",
    linkedin: "#",
    instagram: "#",
    appstore: "#",
    playstore: "#",
    twitter: "#",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/cust_api/get_setting`
        );
        if (response.data.status === 1 && response.data.data.length > 0) {
          const data = response.data.data[0];
          setSocialLinks({
            facebook: data.facebook || "#",
            youtube: data.youtube || "#",
            linkedin: data.linkedin || "#",
            instagram: data.instagram || "#",
            appstore: data.appstore || "#",
            playstore: data.playstore || "#",
            twitter: data.twitter || "#",
          });
        }
      } catch (error) {
        console.error("Error fetching social links:", error);
      }
    };
    fetchSettings();
  }, []);

  const icons = [
    { icon: FaFacebookF, link: socialLinks.facebook, bg: "bg-[#3b5998]" },
    { icon: FaYoutube, link: socialLinks.youtube, bg: "bg-[#ff0000]" },
    { icon: FaLinkedinIn, link: socialLinks.linkedin, bg: "bg-[#0077b5]" },
    { icon: FaInstagram, link: socialLinks.instagram, bg: "bg-gradient-to-tr from-amber-500 via-rose-500 to-purple-600" },
    { icon: FaXTwitter, link: socialLinks.twitter, bg: "bg-black" },
  ];

  const citiesList = [
    "Mumbai",
    "Delhi",
    "Bengaluru",
    "Chennai",
    "Hyderabad",
    "Kolkata",
    "Pune",
    "Indore",
    "Ahmedabad",
    "Jaipur",
    "Noida",
    "Gurgaon",
  ];

  return (
    <footer className="relative bg-white text-gray-700 pt-10 overflow-hidden border-t border-gray-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        {/* Main Grid Section */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 pb-8">

          {/* Column 1: Brand Info & Highlights */}
          <div className="lg:col-span-4 flex flex-col justify-between">
            <div>
              <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                <img
                  src="/app1.png"
                  alt="ZEROBRIKS Logo"
                  className="h-18 w-auto object-contain mb-3"
                />
              </Link>
              <p className="text-gray-500 text-xs leading-relaxed mb-5">
                ZEROBRIKS is a next-generation real estate platform connecting verified owners, buyers, tenants and builders directly for a transparent, faster and zero-brokerage property experience.
              </p>

              {/* Feature Highlights Grid */}
              <div className="grid grid-cols-4 gap-2 mb-6">
                <div className="bg-[#fdf2f4] rounded-xl p-2 text-center flex flex-col items-center justify-center border border-[#f8d7da]">
                  <div className="w-8 h-8 rounded-full bg-[#f7d6de] text-[#700c28] flex items-center justify-center mb-1">
                    <IoHomeOutline size={16} />
                  </div>
                  <span className="text-[10px] font-bold text-gray-800 leading-tight">Zero<br />Brokerage</span>
                </div>

                <div className="bg-[#fdf2f4] rounded-xl p-2 text-center flex flex-col items-center justify-center border border-[#f8d7da]">
                  <div className="w-8 h-8 rounded-full bg-[#f7d6de] text-[#700c28] flex items-center justify-center mb-1">
                    <IoShieldCheckmarkOutline size={16} />
                  </div>
                  <span className="text-[10px] font-bold text-gray-800 leading-tight">Verified<br />Properties</span>
                </div>

                <div className="bg-[#fdf2f4] rounded-xl p-2 text-center flex flex-col items-center justify-center border border-[#f8d7da]">
                  <div className="w-8 h-8 rounded-full bg-[#f7d6de] text-[#700c28] flex items-center justify-center mb-1">
                    <IoPeopleOutline size={16} />
                  </div>
                  <span className="text-[10px] font-bold text-gray-800 leading-tight">Direct<br />Connection</span>
                </div>

                <div className="bg-[#fdf2f4] rounded-xl p-2 text-center flex flex-col items-center justify-center border border-[#f8d7da]">
                  <div className="w-8 h-8 rounded-full bg-[#f7d6de] text-[#700c28] flex items-center justify-center mb-1">
                    <IoTrendingUpOutline size={16} />
                  </div>
                  <span className="text-[10px] font-bold text-gray-800 leading-tight">Buy • Rent •<br />Sell • Invest</span>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2: Company Navigation Links */}
          <div className="lg:col-span-2">
            <h3 className="text-[#1a2332] text-xs font-bold tracking-wider uppercase mb-4">
              COMPANY
            </h3>
            <ul className="space-y-2 text-xs">
              {[
                { name: "FAQ", path: "/faq" },
                { name: "About Us", path: "/about-us" },
                { name: "How It Works", path: "/about-us" },
                { name: "Contact Us", path: "/contact" },
                { name: "NRI Services", path: "/nri" },
                { name: "Privacy Policy", path: "/privacy-policy" },
                { name: "Terms of Service", path: "/terms-conditions" },
              ].map((item, idx) => (
                <li key={idx}>
                  <button
                    onClick={() => handleNavigation(item.path)}
                    className="flex items-center gap-1.5 text-gray-600 hover:text-[#700c28] transition-colors"
                  >
                    <FaChevronRight size={9} className="text-[#700c28]" />
                    <span>{item.name}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Properties in India */}
          <div className="lg:col-span-3">
            <h3 className="text-[#1a2332] text-xs font-bold tracking-wider uppercase mb-4">
              PROPERTIES IN INDIA
            </h3>
            <div className="grid grid-cols-2 gap-y-2 gap-x-2 text-xs">
              {citiesList.map((city) => (
                <button
                  key={city}
                  onClick={() => handleCityClick(city)}
                  className="flex items-center gap-1 text-gray-600 hover:text-[#700c28] text-left transition-colors truncate"
                >
                  <HiOutlineLocationMarker size={13} className="text-[#700c28] flex-shrink-0" />
                  <span className="truncate">Property in {city}</span>
                </button>
              ))}
            </div>

            {/* Explore Properties Action Banner */}
            <button
              onClick={() => handleNavigation("/")}
              className="mt-5 w-full py-2 px-3 bg-[#fdf2f4] hover:bg-[#f7d6de] border border-[#f8d7da] rounded-xl flex items-center justify-between text-[#700c28] font-semibold text-xs transition-all"
            >
              <span className="flex items-center gap-1.5">
                <FaBuilding size={12} />
                Explore Properties in All Cities
              </span>
              <FaChevronRight size={10} />
            </button>
          </div>

          {/* Column 4: App Download & Socials */}
          <div className="lg:col-span-3">
            <h3 className="text-[#1a2332] text-xs font-bold tracking-wider uppercase mb-3">
              GET THE ZEROBRIKS APP
            </h3>
            <p className="text-gray-500 text-xs mb-3">
              Search properties, connect directly and manage everything on the go.
            </p>

            {/* App Badges */}
            <div className="flex gap-2 mb-3">
              <a
                href={socialLinks.playstore}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-90 transition-opacity"
              >
                <img
                  src="/image/abc.jpg"
                  alt="Google Play"
                  className="h-9 w-auto rounded-md border border-gray-200"
                />
              </a>
              <a
                href={socialLinks.appstore}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-90 transition-opacity"
              >
                <img
                  src="/image/apl.png"
                  alt="App Store"
                  className="h-9 w-auto rounded-md border border-gray-200"
                />
              </a>
            </div>

            {/* QR Card */}
            <div className="bg-white border border-gray-200 rounded-xl p-2.5 flex items-center gap-3 shadow-sm mb-5">
              <img
                src="/image/qrbar.jpg"
                alt="Scan QR"
                className="w-12 h-12 object-contain"
              />
              <div>
                <span className="text-xs font-bold text-gray-800 block">Scan QR Code</span>
                <span className="text-[10px] text-gray-500 flex items-center gap-1">
                  Download ZEROBRIKS App <FaChevronRight size={8} className="text-[#700c28]" />
                </span>
              </div>
            </div>

            {/* Social Icons */}
            <div>
              <h4 className="text-[#1a2332] text-xs font-bold tracking-wider uppercase mb-2">
                FOLLOW US
              </h4>
              <div className="flex gap-2">
                {icons.map(({ icon: Icon, link, bg }, index) => (
                  <a
                    key={index}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-8 h-8 rounded-lg ${bg} text-white flex items-center justify-center hover:opacity-90 transition-all shadow-sm`}
                  >
                    <Icon size={14} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Contact Info Strip */}
        <div className="bg-white border border-gray-200 rounded-2xl p-4 shadow-sm mb-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-[#fdf2f4] text-[#700c28] flex items-center justify-center flex-shrink-0">
              <FaPhoneAlt size={14} />
            </div>
            <div>
              <span className="text-[10px] text-gray-400 block font-medium">Call Us (Toll Free)</span>
              <span className="text-xs font-bold text-gray-800">+91 8681800029</span>
              <span className="text-[9px] text-gray-400 block">9:30 AM to 6:30 PM (Mon-Sun)</span>
            </div>
          </div>

          <div className="flex items-center gap-3 border-t md:border-t-0 md:border-l border-gray-100 pt-3 md:pt-0 md:pl-4">
            <div className="w-9 h-9 rounded-full bg-[#fdf2f4] text-[#700c28] flex items-center justify-center flex-shrink-0">
              <FaEnvelope size={14} />
            </div>
            <div>
              <span className="text-[10px] text-gray-400 block font-medium">Email Support</span>
              <span className="text-xs font-bold text-gray-800">support@zerobriks.com</span>
              <span className="text-[9px] text-gray-400 block">We usually respond within 24 hours</span>
            </div>
          </div>

          <div className="flex items-center gap-3 border-t md:border-t-0 md:border-l border-gray-100 pt-3 md:pt-0 md:pl-4">
            <div className="w-9 h-9 rounded-full bg-[#fdf2f4] text-[#700c28] flex items-center justify-center flex-shrink-0">
              <HiOutlineLocationMarker size={16} />
            </div>
            <div>
              <span className="text-[10px] text-gray-400 block font-medium">Our Office</span>
              <span className="text-xs font-bold text-gray-800">Chennai, Tamil Nadu, India</span>
              <span className="text-[9px] text-gray-400 block">Registered Business Address</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Wave Banner Footer Bar */}
      <div className="bg-[#700c28] text-white py-3.5 relative">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center justify-between text-xs gap-2">
          <p className="text-gray-200 text-[11px]">
            © 2026 ZEROBRIKS. All Rights Reserved.
          </p>

          <div className="flex items-center gap-4 text-white text-[11px]">
            <Link
              to="/privacy-policy"
              className="text-gray-200 hover:text-white transition-colors no-underline"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-400">|</span>
            <Link
              to="/terms-conditions"
              className="text-gray-200 hover:text-white transition-colors no-underline"
            >
              Terms of Service
            </Link>
            <span className="text-gray-400">|</span>
            <Link
              to="/sitemap"
              className="text-gray-200 hover:text-white transition-colors no-underline"
            >
              Sitemap
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;